var render = function () {
var _obj, _obj$1, _obj$2, _obj$3, _obj$4;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    absolute: true,
    'right-1.75': !_vm.isStream,
    'top-1.75': !_vm.isStream,
    'right-2.75': _vm.isStream,
    'top-2.75': _vm.isStream,
    group: true,
  }},[_c('div',{staticClass:"transform -translate-x-px translate-y-px"},[_c('div',{class:{
        'h-5 w-min': true,
        relative: true,
        flex: true,
        'pl-1': true,
        'overflow-hidden': !_vm.isTouchable,
        'overflow-visible': _vm.isTouchable,
      }},[(_vm.xEditPost)?_c('div',{class:( _obj = {
          'transition-all': true,
          'group-hover:animate-slide-from-right': true,
          'rounded-bl-lg': true,
          'pr-1': true,
          '-mr-1': true,
          'transform translate-x-full group-hover:translate-x-0': true,
          'flex justify-start items-start': true
        }, _obj[_vm.colorClasses[0]] = _vm.colorScheme === 'light', _obj[_vm.colorClasses[1]] = _vm.colorScheme === 'dark', _obj )},[(_vm.xOverlay)?_c('div',{class:[
            'absolute left-px transform -translate-x-full -translate-y-px',
            ( _obj$1 = {}, _obj$1[_vm.colorClasses[2]] = _vm.colorScheme === 'light', _obj$1[_vm.colorClasses[3]] = _vm.colorScheme === 'dark', _obj$1 ) ]}):_vm._e(),_vm._v(" "),_c('oz-button',{class:{
            'h-4': true,
            'font-semibold': true,
            'hover-hover:hover:font-semibold': true,
            'bg-transparent': true,
            'text-dark-text-200': _vm.colorScheme === 'light',
            'text-light-text-200': _vm.colorScheme === 'dark',
            'hover-hover:hover:text-dark-text-100': _vm.colorScheme === 'light',
            'hover-hover:hover:text-light-text-100': _vm.colorScheme === 'dark',
            'hover-hover:focus:text-grape-500': _vm.colorScheme === 'light',
            'hover-hover:focus:text-canary-500': _vm.colorScheme === 'dark',
            'hover-hover:active:text-grape-500': _vm.colorScheme === 'light',
            'hover-hover:active:text-canary-500': _vm.colorScheme === 'dark',
          },attrs:{"type":"custom","color-scheme":"secondary","dark-theme-type":"custom","is-dark":_vm.colorScheme === 'dark',"font-size":12,"should-fix-height":false,"x-text-padding":false},on:{"click":function($event){return _vm.$emit('edit')}}},[_vm._v(_vm._s(_vm._f("__")('Edit')))])],1):_vm._e(),_vm._v(" "),(_vm.xEditPost)?_c('div',{class:{
          'z-20': true,
          'hidden group-hover:flex': true,
          'animate-fade-in-fast': true,
          'h-4': true,
          'mb-1': true,
          'w-px': true,
          'border-l-[0.5px] border-solid': true,
          'border-dark-text-400': _vm.colorScheme === 'light',
          'border-light-text-400': _vm.colorScheme === 'dark',
        }}):_vm._e(),_vm._v(" "),_c('div',{class:( _obj$2 = {
          'w-4 h-5': true,
          'z-10': true,
          '-mr-0.5': true,
          flex: true,
          relative: true,
          'overflow-visible': true,
          'justify-end': true,
          'rounded-bl-lg': true,
          'group-hover:rounded-none': _vm.xEditPost,
          'group-hover:transition-all': true
        }, _obj$2[_vm.colorClasses[0]] = _vm.colorScheme === 'light', _obj$2[_vm.colorClasses[1]] = _vm.colorScheme === 'dark', _obj$2 )},[(_vm.xOverlay)?_c('div',{class:[
            'absolute left-px transform -translate-x-full -translate-y-px ',
            ( _obj$3 = {}, _obj$3[_vm.colorClasses[2]] = _vm.colorScheme === 'light', _obj$3[_vm.colorClasses[3]] = _vm.colorScheme === 'dark', _obj$3['group-hover:animate-disappear-after'] =  _vm.xEditPost, _obj$3 ) ]}):_vm._e(),_vm._v(" "),_c('oz-button',{class:{
            'flex-shrink-0': true,
            'w-12 h-12 pl-8 pb-8': _vm.isTouchable,
            'w-4 h-4': !_vm.isTouchable,
            'p-0': true,
            'text-dark-text-200': _vm.colorScheme === 'light',
            'text-light-text-200': _vm.colorScheme === 'dark',
            'hover-hover:hover:text-grape-500': _vm.colorScheme === 'light',
            'hover-hover:hover:text-canary-500': _vm.colorScheme === 'dark',
          },attrs:{"type":"text","icon-name":"more_vertical","color-scheme":"secondary","icon-size":16,"dark-theme-type":"custom","is-dark":_vm.colorScheme === 'dark',"should-fix-width":false,"should-fix-height":false},on:{"click":function($event){return _vm.$emit('dropdown')}}})],1)]),_vm._v(" "),(_vm.xOverlay)?_c('div',{class:[
        'absolute bottom-px right-0 transform translate-x-px translate-y-full',
        ( _obj$4 = {}, _obj$4[_vm.colorClasses[2]] = _vm.colorScheme === 'light', _obj$4[_vm.colorClasses[3]] = _vm.colorScheme === 'dark', _obj$4 ) ]}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }